export const normalizeSharedCardAutomation = automation => ({
  ...automation,
  allow_shared_card_editors: automation?.allow_shared_card_editors === true,
});

export const sharedCardAutomationPayload = allowSharedCardEditors => ({
  allow_shared_card_editors: allowSharedCardEditors === true,
});
